const STATUS_OPEN = 'Open'
const STATUS_DRAFT = 'Draft'

export default () => ({
    debounce: null,
    orderId: null,

    async init() {
        this.orderId = await this.$wire.getOrderId();
        if (! this.orderId) {
            return;
        }

        this.checkStatus();
    },

    checkStatus() {
        clearTimeout(this.debounce);

        fetch('order/' + this.orderId + '/status')
            .then(response => response.json())
            .then(({status, error}) => {
                if((status != STATUS_OPEN && status != STATUS_DRAFT) || error) {
                    clearTimeout(this.debounce);
                    this.$wire.checkOrderStatus(status, error);

                    return;
                }

                if((status === STATUS_OPEN)) {
                    clearTimeout(this.debounce);
                    this.$wire.checkOrderStatus(status);

                    return;
                }

                this.debounce = setTimeout(() => {
                    this.checkStatus();
                }, 1000);
            });
    }
});
